export const navigationConfig = [
	{
		path: '/dashboard',
		title: 'Dashboard',
		role: 'menu:dashboard',
		iconClass: 'fa-home',
		shortcut: 'D'
	},
	{
		path: '/tariffcodes',
		title: 'Zones',
		role: 'menu:tariffcodes',
		iconClass: 'fa-map',
		shortcut: 'Z'
	},
	{
		path: '/resellers',
		title: 'Resellers',
		role: 'menu:resellers',
		iconClass: 'fa-building',
		shortcut: 'L'
	},
	{
		path: '/tenants',
		title: 'Tenants',
		role: 'menu:tenants',
		iconClass: 'fa-users',
		shortcut: 'T'
	},
	{
		path: '/carriers',
		title: 'Carriers',
		role: 'menu:carriers',
		iconClass: 'fa-satellite-dish',
		shortcut: 'C'
	},
	{
		path: '/lcrs',
		title: 'LCRs',
		role: 'menu:lcrs',
		iconClass: 'fa-arrows-turn-to-dots',
		shortcut: 'X'
	},
	{
		path: '/tariffs',
		title: 'Tariffs',
		role: 'menu:tariffs',
		iconClass: 'fa-money-bill-transfer',
		shortcut: 'I'
	},
	{
		path: '/tariffprofiles',
		title: 'Routes',
		role: 'menu:tariffprofiles',
		iconClass: 'fa-key',
		shortcut: 'E'
	},
	{
		path: '/accounts',
		title: 'Accounts',
		role: 'menu:accounts',
		iconClass: 'fa-user',
		shortcut: 'A'
	},
	{
		path: '/phonenumbers',
		title: 'Numbers',
		role: 'menu:phonenumbers',
		iconClass: 'fa-phone',
		shortcut: 'P'
	},
	{
		path: '/files',
		title: 'My Files',
		role: 'menu:files',
		iconClass: 'fa-folder',
		shortcut: 'M'
	},
	{
		path: '/flows',
		title: 'Flows',
		role: 'menu:flows',
		iconClass: 'fa-kit fa-teleflow text-sm',
		shortcut: 'F'
	},
	{
		path: '/siptrunks',
		title: 'SIP Trunks',
		role: 'menu:siptrunks',
		iconClass: 'fa-lock',
		shortcut: 'K'
	},
	{
		path: '/featurecodes',
		title: 'Feature Codes',
		role: 'menu:featurecodes',
		iconClass: 'fa-input-numeric',
		shortcut: 'N'
	},
	{
		path: '/mobilesims',
		title: 'Mobile',
		role: 'menu:mobilesims',
		iconClass: 'fa-sim-card',
		shortcut: 'S',
		new: true
	},
	{
		path: '/porting',
		title: 'Porting',
		role: 'menu:numberports',
		iconClass: 'fa-exchange',
		shortcut: 'O'
	},
	{
		path: '/devices',
		title: 'Devices',
		role: 'menu:devices',
		iconClass: 'fa-router',
		shortcut: 'V'
	},
	{
		path: '/calls',
		title: 'Search Calls',
		role: 'menu:reports',
		iconClass: 'fa-magnifying-glass',
		shortcut: 'U'
	},
	{
		path: '/reports',
		title: 'Reports',
		role: 'menu:reports',
		iconClass: 'fa-pie-chart',
		shortcut: 'Y'
	},
	{
		path: '/realtime',
		title: 'Realtime',
		role: 'menu:diagnostics',
		iconClass: 'fa-wave-pulse',
		shortcut: 'R'
	},
	{
		path: '/users',
		title: 'Users',
		role: 'menu:users',
		iconClass: 'fa-users',
		shortcut: 'W'
	}
]

export const getFilteredNavigation = (userRoles, global) => {
	return navigationConfig.filter((item) => !item.role || global.hasUserRole(userRoles, item.role))
}

export const getNavigationItem = (path) => {
	return navigationConfig.find((item) => item.path === path)
}
